import { string } from "prop-types";

const AmsterdamCentrum = ({ className }) => (
  <path
    d="M563 215.055H582.745L591.195 253.986L617.731 273.576H636.622L679.097 297.641L687.39 293.512L703.568 302.184V331.089H683.658L659.609 354.213L630.585 359.994L617.731 369.492H577.927L550.561 349.671L529 300.119L563 215.055Z"
    fill="url(#paint10_linear_14735_232327)"
    fillOpacity="0.25"
    stroke="#4D4D4D"
    strokeWidth="2"
    strokeMiterlimit="10"
    strokeDasharray="4 4"
    className={className}
  />
);

AmsterdamCentrum.propTypes = {
  className: string,
};

export default AmsterdamCentrum;
